import { LuLeaf, LuDroplets, LuShieldCheck, LuUsers } from "react-icons/lu";

export const whyChooseDetails = [
  {
    id: 1,
    icon: LuLeaf,
    title: "Made with Arnica Extract",
    description:
      "Nature-derived actives known to calm the scalp and strengthen roots.",
  },
  {
    id: 2,
    icon: LuDroplets,
    title: "Reduces Hair Fall",
    description:
      "Gentle, pH-balanced cleansing that protects hair from breakage.",
  },
  {
    id: 3,
    icon: LuShieldCheck,
    title: "Dermatologically Tested",
    description: "Paraben, urea and salt free, safe for daily family use.",
  },
  {
    id: 4,
    icon: LuUsers,
    title: "Trusted by Families",
    description: "Loved by thousands of Indian households across the country.",
  },
];
